export default "__VITE_ASSET__cfb2e832__"